import { CONSTANTS } from '@shared/constants';

export const VENUE_USERS_ROUTES_PATHS_PARTIALS = {
  BASE_PATH: CONSTANTS.ROUTES.USERS,
  INVITE: CONSTANTS.ROUTES.INVITE,
  EDIT: `${CONSTANTS.ROUTES.EDIT}/:${CONSTANTS.ROUTE_PARAMS.USER_ID}`,
};
export const VENUE_USERS_ROUTES_PATHS_FULL = {
  INVITE: `${VENUE_USERS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_USERS_ROUTES_PATHS_PARTIALS.INVITE}`,
  EDIT: `${VENUE_USERS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${VENUE_USERS_ROUTES_PATHS_PARTIALS.EDIT}`,
};
